<script lang="ts">
	import { twJoin, twMerge } from "tailwind-merge";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import Icon from "#lib/components/Icon.svelte";
	import P from "#lib/components/P.svelte";
	import AppSwitcher from "#lib/components/flow/viewer/AppSwitcher.svelte";
	import type { AppSwitcherLayoutProps } from "#lib/components/flow/viewer/types.js";

	const { apps, maxVisibleModules, metadata, readOnly = false, interpolate = false, mode = Mode.LIVE, layoutName, themeStyle, classes, isLightBackground, accessory, class: className, onExecute, onCancel, onShow, onEdit, onMore }: AppSwitcherLayoutProps = $props();
	const max = $derived(maxVisibleModules || apps.length);
</script>

<div class={twMerge("flex flex-col gap-3", className)}>
	{#each apps.slice(0, max) as page, i (page.key)}
		<div class="relative">
			<AppSwitcher {metadata} {layoutName} {themeStyle} {isLightBackground} {classes} {onExecute} {onCancel} {onShow} {onEdit} {page} {mode} {readOnly} {interpolate} />
			{@render accessory?.(i)}
		</div>
	{/each}
	{#if maxVisibleModules && apps.length > maxVisibleModules}
		<div class="relative">
			<button type="button" data-flow-button disabled={readOnly} onclick={onMore} class={twMerge("flex w-full items-center rounded-2xl border border-gray-300 bg-white p-2.5", readOnly && "disabled:pointer-events-none disabled:cursor-pointer disabled:opacity-100")}>
				<Icon height="32" width="32" name="squares-2x2" class="m-auto flex-none text-gray-400 dark:text-gray-400" />
				<P align="left" class={twJoin("ml-2 grow text-sm font-semibold text-gray-900")}>More</P>
				<div><Icon name="chevron-right" class="h-5 w-5 text-gray-400" /></div>
			</button>
			{#each apps.slice(max) as page, i (page.key)}
				{@render accessory?.(max + i)}
			{/each}
		</div>
	{/if}
</div>
